import slardar from '@jupiter/plugin-runtime/slardar';
import { Logger } from '@i18n-ecom-alliance/lib-sdk';

const logger = new Logger(slardar);

export default logger;
